module.exports = __webpack_public_path__ + "static/media/Tredence-Logo.8a5690a1.svg";